import { stringify } from 'query-string';
import { DEFAULT_SORT, SORT, SORTBY, PAGINATION_QUERY } from '../constants';
import updateSort from './update-sort';
const handleSortUpdate = ({
  router,
  value,
  query,
  url,
  selectLabel,
  listComponentName
}) => {
  const queryWithoutSort = {};
  const routerOptions = {
    shallow: true,
    scroll: false
  };
  const {
    asPath
  } = router;
  const hashBit = asPath.split('#')[1];
  const parsedHash = hashBit ? `#${hashBit}` : '';
  const listNameKey = listComponentName ? `pb[${listComponentName}]` : '';
  const sortString = listNameKey ? `[${SORT}]` : SORT;
  const sortByString = listNameKey ? `[${SORTBY}]` : SORTBY;
  const sortKey = `${listNameKey}${sortString}`;
  const sortByKey = `${listNameKey}${sortByString}`;
  Object.keys(query).forEach(key => {
    if (key.indexOf(PAGINATION_QUERY) !== -1) return;
    if (key !== sortByKey && key !== sortKey) queryWithoutSort[key] = query[key];
  });
  if (value === DEFAULT_SORT || value === selectLabel) {
    const stringifiedQuery = stringify(queryWithoutSort);
    return stringifiedQuery ? router.push(`/Resolver`, `${url}?${stringifiedQuery}${parsedHash}`, routerOptions) : router.push(`/Resolver`, `${url}${parsedHash}`, routerOptions);
  }
  const updatedSortUrl = updateSort(value, queryWithoutSort, url, parsedHash, listComponentName);
  return router.push('/Resolver', updatedSortUrl, routerOptions);
};
export default handleSortUpdate;
//# sourceMappingURL=handle-sort-update.js.map